import {ResourceType} from '../../../../@types/resource-type';
import {SelectedWorkspaceObject} from '../../../../@types/workspace-types';

/**
 * Whether an open canvas should redraw from the selected object.
 *
 * <p>It redraws when its own edits marked it dirty, or when something outside it changed the view
 * and asked (the assistant applying a proposal). That request is answered once: the same object
 * selected again, as when the tab is reactivated, redraws only if the canvas is dirty, so selection
 * and scroll are not reset every time the analyst comes back to the tab.</p>
 *
 * @param selected        the workspace's selected object
 * @param viewId          the id of the view the canvas shows
 * @param dirty           whether the canvas's own edits are waiting to be drawn
 * @param alreadyRedrawn  the selected object whose redraw request was last answered
 */
export function shouldRedrawCanvas(
    selected: SelectedWorkspaceObject | null | undefined,
    viewId: number | undefined,
    dirty: boolean,
    alreadyRedrawn: SelectedWorkspaceObject | null,
): boolean {
    if (!selected || selected.objectType !== ResourceType.EVENT_SEQUENCE_TREES || selected.object?.id !== viewId) {
        return false;
    }
    return dirty || (Boolean(selected.redrawCanvas) && selected !== alreadyRedrawn);
}
